export default "__VITE_ASSET__e9b2eebc__"